// extracted by mini-css-extract-plugin
module.exports = {"cardWrap":"style_cardWrap__1z_lp","formWarp":"style_formWarp__2y7Gq","forgotPw":"style_forgotPw__1W3ca","text":"style_text__zA-Lm"};